import styled from 'styled-components';

export const FileWrapper = styled.div`
  margin: 15px 0;
  display: flex;
  flex-direction: column;
`;

export const Types = styled.div`
  margin: 0 15px 15px 15px;
  gap: 1rem;
  display: flex;
`;

export const Sizes = styled.div`
  display: flex;
  justify-content: center;
`;
